const constants = {
  LOCAL_STORAGE: {
    KEYS: {
      USER_EMAIL: "circlefeed_user_email",
      USER_ID: "circlefeed_user_id",
      USER_ROLE: "circlefeed_user_role",
      ACCESS_TOKEN: "circlefeed_access_token",
      FULL_NAME: "circlefeed_fullName",
      LAST_CHECKED_EMAIL: "circlefeed_last_checked_email",
      EMAIL_FROM_LANDING: "circlefeed_email_from_landing",
      LOCALE: "circlefeed_locale",
      COMPANY_ID: "circlefeed_user_company_id",
    },
  },
  CF_START_DAY: "2022-06-1",
  DEFAULT_API_DATE_FORMAT: "YYYY-MM-DD",
};

export default constants;
